import { MenuItem } from '@/interfaces/MenuItem';
import i18n from '@/plugins/i18n/i18n';
import { urls } from '@/shared/urls';

export const profileSideMenu = {
	title: 'Profile',
	url: '',
	children: [
		{
			title: i18n.t('message.profileNavigation.linkedAccounts'),
			url: urls.linkedAccounts
		},
		{
			title: i18n.t('message.profileNavigation.changeEmail'),
			url: urls.changeEmail
		},
		{
			title: i18n.t('message.profileNavigation.changePassword'),
			url: urls.changePassword
		},
		{
			title: i18n.t('message.profileNavigation.deleteAccount'),
			url: urls.deleteAccount
		}
	]
} as MenuItem;
